<template>
  <div class="wrapper">
    <div class="head">
      <h4>投资团队</h4>
    </div>
    <div class="topuser">
      <div
        class="item"
        v-for="(item, index) in topuser"
        :key="index"
        @click="
          changeModel({
            isShow: true,
            name: item.name,
            desc1: item.desc1,
            desc2: item.desc2,
            desc3: item.desc3,
            title: item.title
          })
        "
      >
        <div class="cover" :style="`backgroundImage:url(${item.cover})`"></div>
        <h4>{{ item.name }}</h4>
      </div>
    </div>
    <div class="content">
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="
          changeModel({
            isShow: true,
            name: item.name,
            desc1: item.desc1,
            desc2: item.desc2,
            desc3: item.desc3,
            title: item.title
          })
        "
      >
        <div class="cover" :style="`backgroundImage:url(${item.cover})`"></div>
        <h4>{{ item.name }}</h4>
      </div>
      <div class="item">
        <div class="cover mydefault"></div>
        <h4>期待您的加入</h4>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Model from "./model";
import { userChines, TopUser } from "@/util/text";
export default {
  data() {
    return {
      isShow: false,
      name: "",
      desc1: "",
      desc2: "",
      desc3: "",
      title: "",
      topuser: TopUser
    };
  },
  computed: {
    ...mapGetters({
      language: "getType"
    }),
    list() {
      return this.language == "中文" ? [...userChines] : [...userChines];
    }
  },

  methods: {
    changeModel(value = true, name, desc1, desc2, desc3, title) {
      this.isShow = value;
      this.name = name;
      this.desc1 = desc1;
      this.desc2 = desc2;
      this.desc3 = desc3;
      this.title = title;
    },
    ...mapMutations(["changeModel"])
  },
  components: {
    Model
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  padding-bottom: 1rem;
  .head {
    width: 3.24rem;
    border-bottom: 0.01rem solid rgba(51, 51, 51, 0.25);
    padding-bottom: 0.13rem;
    margin: 0.4rem auto 0;
    h4 {
      font-size: 0.36rem;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      opacity: 0.9;
      text-align: center;
    }
  }
  .topuser {
    width: 90% !important;
    margin: 0.26rem auto 0 !important;
    justify-content: space-around;
  }

  .content,
  .topuser {
    width: 100%;
    box-sizing: border-box;
    // margin-top: 0.66rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -o-flex-wrap: wrap;
    flex-wrap: wrap;

    .item {
      width: 2.44rem;
      height: 3.28rem;
      text-align: center;
      background: url("../images/userbg.png");
      background-size: 100% 100%;
      &:nth-child(3n + 1) {
        margin-left: 0.12rem;
      }
      .mydefault {
        width: 3.13rem;
        height: 3.13rem;
        background: url("../images/default.png") no-repeat;
        background-size: contain;
      }
      .cover {
        width: 1.92rem;
        height: 1.92rem;
        background-size: 100% 100%;
        margin: 0.23rem;
        position: relative;

        .marsk {
          position: absolute;
          width: 100%;
          height: 100%;
          opacity: 0;
          z-index: 10;
          top: 0;
          left: 0;
        }
      }
      h4 {
        font-size: 0.26rem;
        font-weight: 600;
        color: rgba(78, 78, 78, 1);
      }
      .desc {
        font-size: 0.22rem;
        color: rgba(78, 78, 78, 1);
        margin-top: 0.05rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/team.vue